import { render, staticRenderFns } from "./unignore-customs-validation.vue?vue&type=template&id=4b1d38ed&scoped=true"
import script from "./unignore-customs-validation.vue?vue&type=script&lang=js"
export * from "./unignore-customs-validation.vue?vue&type=script&lang=js"
import style0 from "./unignore-customs-validation.vue?vue&type=style&index=0&id=4b1d38ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d38ed",
  null
  
)

export default component.exports